import type { CreateStoreResult } from '@ms/yammer-data';
import { createStore } from '@ms/yammer-data';
import type { ReducersMapObject } from 'redux';

import widgetConfigurationReducer from '../../../state/reducer';
import type { YammerEmbedState } from '../../../state/types';
import { persistConfig } from '../../persistedState';

export const createYammerEmbedStore: () => CreateStoreResult<YammerEmbedState> = () => {
  const reducers: ReducersMapObject<Partial<YammerEmbedState>> = {
    widgetConfiguration: widgetConfigurationReducer,
  };

  return createStore<YammerEmbedState>({ reducers, persistConfig });
};
